/* Business reputation only. Public feed totals include Google from both locations. */
(() => {
  const key = 'va-combined-reviews-v1', ttl = 60 * 60 * 1000;
  let latest;
  const valid = stats => stats && Number.isInteger(stats.company) && stats.company > 0 && Number.isInteger(stats.google) && stats.google >= 0 && stats.rating >= 1 && stats.rating <= 5;
  function apply(stats) {
    if (!valid(stats)) return;
    latest = stats;
    const count = (stats.company + stats.google).toLocaleString('en-GB');
    const rating = Number(stats.rating).toFixed(1);
    document.querySelectorAll('[data-va-combined-count]').forEach(el => { el.textContent = count; });
    document.querySelectorAll('[data-va-combined-rating]').forEach(el => { el.textContent = rating; });
    document.querySelectorAll('[data-va-company-count]').forEach(el => { el.textContent = stats.company.toLocaleString('en-GB'); });
    document.querySelectorAll('[data-va-google-count]').forEach(el => { el.textContent = stats.google.toLocaleString('en-GB'); });
    document.querySelectorAll('[data-va-review-summary]').forEach(root => {
      const link = root.querySelector('a');
      const template = root.querySelector('[data-summary-label]')?.dataset.summaryLabel;
      if (link && template) link.setAttribute('aria-label', template.replace('{count}', count).replace('{rating}', rating));
    });
    document.documentElement.dataset.vaCombinedReviews = 'updated';
  }
  function controls() {
    document.querySelectorAll('[data-va-review-breakdown]').forEach((root, i) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const button = root.querySelector('button'), panel = root.querySelector('[role="tooltip"]');
      panel.id = 'VaReviewBreakdown-' + i;
      button.setAttribute('aria-describedby', panel.id);
      button.setAttribute('aria-controls', panel.id);
      // A body-level panel stays visible outside the hero's clipped artwork.
      document.body.append(panel);
      let pinned = false, closeTimer;
      function position() {
        if (panel.hidden) return;
        const target = button.getBoundingClientRect(), box = panel.getBoundingClientRect();
        const left = Math.max(12, Math.min(target.right + 8, document.documentElement.clientWidth - box.width - 12));
        const top = Math.max(12, target.top - box.height - 8);
        panel.style.left = left + 'px';
        panel.style.top = top + 'px';
      }
      function show(open) {
        clearTimeout(closeTimer);
        panel.hidden = !open;
        button.setAttribute('aria-expanded', String(open));
        if (open) position();
      }
      function leave() {
        if (!pinned && document.activeElement !== button) closeTimer = setTimeout(() => show(false), 180);
      }
      button.addEventListener('click', () => { pinned = !pinned; show(pinned); });
      root.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') show(true); });
      root.addEventListener('pointerleave', leave);
      panel.addEventListener('pointerenter', () => clearTimeout(closeTimer));
      panel.addEventListener('pointerleave', leave);
      button.addEventListener('focus', () => show(true));
      button.addEventListener('blur', () => { if (!pinned) show(false); });
      document.addEventListener('click', event => {
        if (!root.contains(event.target) && !panel.contains(event.target)) { pinned = false; show(false); }
      });
      document.addEventListener('keydown', event => { if (event.key === 'Escape') { pinned = false; show(false); } });
      window.addEventListener('resize', position);
      window.addEventListener('scroll', position, { passive: true });
    });
  }
  async function feed(type, combined = false) {
    const url = new URL('https://api.reviews.io/timeline/data');
    Object.entries({ type, store: 'vanarthur-com', sort: 'date_desc', page: '1', per_page: '1' }).forEach(([k,v]) => url.searchParams.set(k,v));
    if (combined) url.searchParams.set('include_local_reviews', '1');
    const response = await fetch(url, { credentials: 'omit', signal: AbortSignal.timeout(8000) });
    if (!response.ok) throw new Error('Review feed unavailable');
    return response.json();
  }
  async function refresh() {
    if (!document.querySelector('[data-va-combined-count]')) return;
    controls();
    if (latest && Date.now() - latest.time < ttl) { apply(latest); return; }
    try { const cached = JSON.parse(localStorage.getItem(key)); if (valid(cached) && Date.now() - cached.time < ttl) { apply(cached); return; } } catch {}
    try {
      const [company, google, combined] = await Promise.all([feed('store_review'), feed('store_third_party_review'), feed('store_review', true)]);
      const stats = { company: Number(company.stats.results_count), google: Number(google.stats.results_count), rating: Number(combined.stats.average_rating), time: Date.now() };
      // Reject inconsistent snapshots rather than displaying an incorrect source breakdown.
      if (!valid(stats) || stats.company + stats.google !== Number(combined.stats.results_count)) throw new Error('Inconsistent review totals');
      apply(stats);
      try { localStorage.setItem(key, JSON.stringify(stats)); } catch {}
    } catch { document.documentElement.dataset.vaCombinedReviews = 'fallback'; }
  }
  function init() { controls(); refresh(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  setInterval(refresh, ttl);
})();

